<template>
  <list-layout :tableTools="toggleTableTools">
    <template slot="header">
      <BaseHeader :content="header" />
    </template>
    <template slot="table-core">
      <base-table-pagination
        :total="pagination.total"
        :currentPage="pagination.currentPage"
        :perPage="pagination.pageSize"
        @changeCurrentPage="changeCurrentPage"
        @changePerPage="changePerPage"
      ></base-table-pagination>
      <div class="flex flex-row w-100">
        <base-table-searches @toggleSearchesDialog="toggleSearchesDialog" />
        <base-table-search @toggleFilters="toggleFilters" />
      </div>
    </template>
    <template slot="table-tags">
      <base-table-filter-tags  :tags="tags" @removeTag="removeFilterTagHanlder" @removeAllTags="removeAllTagsHandler" @saveTags="saveTagsHandler"/>
    </template>
    <template slot="table-component">
      <kendo-grid-component
        ref="grid"
        v-model="selected"
        value-key="IdAdministrativeCentre"
        :id-vista="idVista"
        :spanish="spanish"
        :data='data'
        :kendo="kendo"
        :loading='isGeneralLoading'
        :selectedField="selectedField"
        @actionclick='openPath'
        @datastatechange='dataStateChange'>
      </kendo-grid-component>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive v-if="isIssuingCreation || isSocietyCreation" mode='primary' :text="$t('invoices.invoices_issuing.step0.modal_continue')" icon='check' @click='goBack' 
            :loading="isGeneralLoading" :disabled="isGeneralLoading"/>
          <base-button-responsive v-else mode='primary' :text="labelBtnExcel" icon='excelxls' @click='exportExcel' 
            :loading='isGeneralLoading || loadingExcel' :disabled="loadingExcel"/>
          <base-button-responsive v-if="!isRoleUserConsultaProvider" mode="primary" :text="$t('administrativecenter.new')" icon="plus" @click="goNewAdministrativeCenter" 
            :loading="isGeneralLoading" :disabled="isGeneralLoading"/>
        </template>
      </base-footer>
      <base-table-select-actions-expand
        :visibility="hasSelected"
        :selected="rowsSelected"
        :total="rowsTotal"
        :baseDropDownVisible="!isRoleUserConsultaProvider"
      >
        <template slot="commons">
          <base-button size="xs" mode="tools" @click="unselect">
            <base-icon name="vall" size="sm" class="mr-1" />
            {{$t('app.unselect')}}
          </base-button>
        </template>
        <template slot="more" v-if="!isRoleUserConsultaProvider">
          <span v-for="action in listaAcciones" :key="action.IdAccion">
            <base-button-item-list theme="dark" @click="executeAction(action)">
              <base-icon :name="action.icon" class="mr-2" />
              {{ action.Descripcion }}
            </base-button-item-list>
          </span>
        </template>
      </base-table-select-actions-expand>
      <Dialog :title="$t('administrativecenter.delete_centers')" :visible.sync="showModal" width="40%" custom-class="min-width-dialog" center>
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessageDelete
        }}</span>
        <template slot="footer">
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
            <base-button class="w-full" @click="showModal = false" mode="secondary-phantom-blue"
              :text="$t('app.cancel')" />
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.apply')"
              @click="() => { deleteHandler(); showModal = false }" />
          </div>
        </template>
      </Dialog>
      <filter-panel :panelOpen="filterPanel" @togglePanel="toggleFilters" @applyFilters="applyFiltersHandler" />
      <create-search-dialog
        :numberSearches="numberSearches"
        :idVista="idVista"
        :dialogOpen="saveSearchDialog"
        :tags="tags"
        @toggleDialog="toggleDialogSearches"
        @applyDialog="applySearchHandler" />
      <filter-panel-searches
        v-if="SendType && !loading"
        ref="filterPanelSearches"
        :idVista="idVista"
        :vuexnamespace="vuexnamespace"
        :panelOpen="searchesPanel"
        @togglePanel="toggleSearchesDialog"
        @applyFilters="applyFiltersHandler"
        @updateNumberSearches="updateNumberSearches"/>
    </template>
  </list-layout>
</template>

<script>
import ListLayout from '@/components/layout/ListLayout.vue'
import FilterPanel from '@/components/filters/AdministrativeCentersFilter.vue'
import FilterPanelSearches from '@/components/searches/SearchesPanel.vue'
import CreateSearchDialog from '@/components/searches/CreateSearchDialog.vue'
import { i18n } from '@/i18n'
import { Dialog } from 'element-ui'
import { setTransitionAllowed } from '@/services/functions/modeAllowedTransitionHelper'
import KendoGridComponent from '@/components/KendoGridComponentV2.vue'

import { getSede } from '@/services/configurations/getSede'
import { getSedesAdministrativeCentersPag } from '@/services/configurations/getSedesAdministrativeCentersPag'
import { getSedesCentrosAdministrativosExcel } from '@/services/configurations/getSedesCentrosAdministrativosExcel'
import { deleteAdministrativeCenter } from '@/services/configurations/deleteAdministrativeCenter'

export default {
  name: 'administrative-centers',
  components: {
    ListLayout,
    FilterPanel,
    FilterPanelSearches,
    CreateSearchDialog,
    KendoGridComponent,
    Dialog,
  },
  props: {
    SendType: {
      type: [String, Boolean],
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      idVista: 61,
      // Searches
      numberSearches: 0,
      saveSearchDialog: false,
      searchesPanel: false,
      // All
      loadingExcel: false,
      showModal: false,
      spanish: true,
      header: {
        title: i18n.t('administrativecenter.header').toUpperCase(),
        icon: 'config',
        breadcrumb: null,
        url: 'masters/society/locations/details',
        params: { issuingCreation: false }
      },
      listaAcciones: [
        { IdAccion: 0, Descripcion: i18n.t('app.remove'), icon: 'trash' },
        // { IdAccion: 1, Descripcion: 'Editar', icon: 'editpencil' },
      ],
      vuexnamespace: 'administrativecenters',
      selectedField: 'selected',
      filterPanel: false,
      showAllRows: true,
      loadingDataTable: false,
      data: null,
      selected: [],
      processMessageDelete: i18n.t('app.delete_selected_confirmation', { entity: i18n.t('administrativecenter.header').toLowerCase() }),
    }
  },
  computed: {
    id: function () {
      return parseInt(this.$route.params.id)
    },
    idSede: function () {
      return parseInt(this.$route.params.idSede)
    },
    // idAC: function () {
    //   return parseInt(this.$route.params.idAC)
    // },
    isRoleUserConsultaProvider: function () {
      return this.role === 1 || this.role === 4 || this.role === 9
    },
    labelBtnExcel: function () {
      if (this.hasSelected) return `${i18n.t('app.export_excel')} (${i18n.t('app.selected')})`
      return i18n.t('app.export_excel')
    },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isHeadCoreReady: function () {
      return this.$store.getters.isHeadCoreReady
    },
    toggleTableTools: function () {
      return this.selected.length > 0
    },
    rowsSelected: function () {
      return this.selected.length
    },
    rowsTotal: function () {
      return this.selected.length
    },
    setLabelTowShow: function () {
      return this.showAllRows ? i18n.t('app.only_selected') : i18n.t('app.see_all')
    },
    masterFilters: function () {
      return this.$store.getters[this.vuexnamespace + '/getMasterFilters']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    isIssuingCreation: function () {
      return !!this.$store.getters['app/isInMode'](1)
    },
    issuingType: function () {
      return this.$store.getters['invoicesIssuing/issuingType']
    },
    isSocietyCreation: function () {
      return !!this.$store.getters['app/isInMode'](2)
    },
    headerCoreFilters: function () {
      return this.$store.getters['auth/queryHeaders']
    },
    tags: function () {
      return this.$store.getters[this.vuexnamespace + '/getTags']
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    columns () {
      return [
        { field: 'selected', width: '50px', headerSelectionValue: this.areAllSelected, reorderable: false, groupable: false },
        ...this.kendo.columns
      ]
    },
    areAllSelected () {
      return this.data.length === this.selected.length
    },
    hasSelected () {
      return this.selected.length > 0
    },
    tiposRolAdministrativeCenter: function () {
      return this.$store.getters['config/TIPOS_ROL_ADMINISTRATIVE_CENTER']
    }
  },
  watch: {
    headerCoreFilters: {
      // immediate: true,
      deep: true,
      handler: 'headerCoreFiltersHandler'
    },
  },
  mounted: async function () {
    if (this.SendType && !this.loading) {
      this.$store.commit(this.vuexnamespace + '/setPageSize', this.kendo.take)
  
      const breadcrumbs = []
      if (this.isIssuingCreation) {
        this.header.url = 'invoicesissuing'
        this.header.params.issuingCreation = true
        this.header.params.issuingType = this.issuingType
        const issuingBreadcrumb = {
          path: 'invoicesissuing',
          name: i18n.t('invoices.invoices_issuing.header_long'),
          params: { issuingCreation: true, issuingType: this.issuingType }
        }
        if (this.issuingType === 2) issuingBreadcrumb.name = i18n.t('invoices.invoices_issuing.proforma.header_long')
        else if (this.issuingType === 3) issuingBreadcrumb.name = i18n.t('invoices.invoices_issuing.quotation.header_long')
        breadcrumbs.push(issuingBreadcrumb)
        breadcrumbs.push({
          path: '',
          name: i18n.t('administrativecenter.header'),
          params: { issuingCreation: true }
        })
      } else {
        breadcrumbs.push({ path: 'masters', name: i18n.t('masters.header') })
        breadcrumbs.push({ path: 'masters/society', name: i18n.t('agenda.sociedad') })
        if (this.isSocietyCreation) {
          this.header.url = 'masters/society'
        } else {
          breadcrumbs.push({ path: 'masters/society/locations', name: i18n.t('sedes.header') }) 
        }
      
        let cabecera = this.$store.getters['app/headerBreadCrumb']
        if (this.$store.getters['app/fromRouteName'] !== null || (cabecera !== null && typeof this.SendType === 'string')) {
          breadcrumbs.push({ path: '', name: cabecera })
        } else {
          const sede = await this.downloadData(this.id)
          cabecera = sede.LocationName || ' '
          breadcrumbs.push({ path: '', name: cabecera })
          this.$store.commit('app/setheaderBreadCrumb', cabecera)
          this.$store.commit('app/setstateBreadCrumb', sede.SendType)
        }
      }
      
  
      this.header.breadcrumb = breadcrumbs
  
      this.data = await this.applyFilters()
    }
  },
  methods: {
    executeAction: async function (action) {
      this.selectedAction = action
      if (this.selectedAction.IdAccion === 0) { // Borrar
        this.deleteAdministrativeCenter()
      } else if (this.selectedAction.IdAccion === 1) { // Editar
        this.editAdministrativeCenter()
      } else {
        console.error(i18n.t('feedback.error.unexpected_action_error', { action: JSON.stringify(action) }))
      }
    },
    deleteAdministrativeCenter: async function () {
      this.showModal = !this.showModal
    },
    deleteHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload ={
          IdSociedad: this.id,
          IdSede: this.idSede,
          IdAdministrativeCentres: this.selected || []
        }
        const response = await deleteAdministrativeCenter(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
          this.unselect()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      this.data = await this.applyFilters()
    },
    openPath: function (event) {
      if (this.isIssuingCreation) {
        setTransitionAllowed(1, true)
      }
      if (this.isSocietyCreation) {
        setTransitionAllowed(2, true)
      }
      this.$store.commit('app/setheaderBreadCrumb', event.dataItem.IdAdministrativeCentre)
      this.$router.push({ 
        name: 'masters/society/locations/administrativecenters/details', 
        params: { 
          id: this.id, 
          idSede: this.idSede,
          idCentro: event.dataItem.IdAdministrativeCentre
        } 
      })
    },
    toggleFilters: function () {
      this.filterPanel = !this.filterPanel
    },
    removeFilterTag: function (tag) {
      this.tags.splice(this.tags.indexOf(tag), 1)
    },
    dataStateChange: async function (event) {
      this.data = await this.applyFilters()
    },
    exportExcel: async function () {
      this.$store.commit('app/setLoading', true)
      this.loadingExcel = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = {
        idSociedad: this.id,
        idSede: this.idSede,
        CentreCode: data.CentreCode ? data.CentreCode.value : null,
        RoleCode: data.RoleCode ? data.RoleCode.value : null,
        Name: data.Name ? data.Name.value : null,
        FirstSurname: data.FirstSurname ? data.FirstSurname.value : null,
        SecondSurname: data.SecondSurname ? data.SecondSurname.value : null,
        Address: data.Address ? data.Address.value : null,
        PostCode: data.PostCode ? data.PostCode.value : null,
        Town: data.Town ? data.Town.value : null,
        Province: data.Province ? data.Province.value : null,
        ContryCode: data.CountryCode ? data.CountryCode.value : null,
        Telephone: data.Telephone ? data.Telephone.value : null,
        TeleFax: data.TeleFax ? data.TeleFax.value : null,
        WebAddress: data.WebAddress ? data.WebAddress.value : null,
        ElectronicMail: data.ElectronicMail ? data.ElectronicMail.value : null,
        ContactPersons: data.ContactPersons ? data.ContactPersons.value : null,
        CnoCnae: data.CnoCnae ? data.CnoCnae.value : null,
        INETownCode: data.INETownCode ? data.INETownCode.value : null,
        AdditionalDetails: data.AdditionalDetails ? data.AdditionalDetails.value : null,
        PhysicalIGLN: data.PhysicalIGLN ? data.PhysicalIGLN.value : null,
        LogicalOperationalPoint: data.LogicalOperationalPoint ? data.LogicalOperationalPoint.value : null,
        CentreDescription: data.CentreDescription ? data.CentreDescription.value : null,
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      const objColumnas = this.getColumnsGroupExcelMixin(this.kendo.columns, this.kendo.group)
      const payload = { order: objOrder.order, grupos: objColumnas }
      if (this.hasSelected) {
        const selectedIDs = this.selected.map(x => x.IdAdministrativeCentre)
        payload.listaIDs = selectedIDs
      }
      try {
        const response = await getSedesCentrosAdministrativosExcel(payload, params)
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = `${(i18n.t('sedes.entity_name')+'-'+i18n.t('administrativecenter.header')).replaceAll(' ', '').toLowerCase()}.xlsx`
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
        this.loadingExcel = false
      }
    },
    applyFilters: async function (eventData) {
      this.loadingDataTable = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = {
        idSociedad: this.id,
        idSede: this.idSede,
        CentreCode: data.CentreCode ? data.CentreCode.value : null,
        RoleCode: data.RoleCode ? data.RoleCode.value : null,
        Name: data.Name ? data.Name.value : null,
        FirstSurname: data.FirstSurname ? data.FirstSurname.value : null,
        SecondSurname: data.SecondSurname ? data.SecondSurname.value : null,
        Address: data.Address ? data.Address.value : null,
        PostCode: data.PostCode ? data.PostCode.value : null,
        Town: data.Town ? data.Town.value : null,
        Province: data.Province ? data.Province.value : null,
        ContryCode: data.CountryCode ? data.CountryCode.value : null,
        Telephone: data.Telephone ? data.Telephone.value : null,
        TeleFax: data.TeleFax ? data.TeleFax.value : null,
        WebAddress: data.WebAddress ? data.WebAddress.value : null,
        ElectronicMail: data.ElectronicMail ? data.ElectronicMail.value : null,
        ContactPersons: data.ContactPersons ? data.ContactPersons.value : null,
        CnoCnae: data.CnoCnae ? data.CnoCnae.value : null,
        INETownCode: data.INETownCode ? data.INETownCode.value : null,
        AdditionalDetails: data.AdditionalDetails ? data.AdditionalDetails.value : null,
        PhysicalIGLN: data.PhysicalIGLN ? data.PhysicalIGLN.value : null,
        LogicalOperationalPoint: data.LogicalOperationalPoint ? data.LogicalOperationalPoint.value : null,
        CentreDescription: data.CentreDescription ? data.CentreDescription.value : null,
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      try {
        const data = await this.getItemsData(objOrder, params)
        return data.map(item => {
          item.RoleTypeDescripcion = this.tiposRolAdministrativeCenter.find(x => x.id === item.RoleTypeDescripcion)?.name ?? item.RoleTypeDescripcion
          return item
        })
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback()
      }
      return this.data
    },
    getItemsData: async function (objOrder, filters) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const res = await this.getMainData(objOrder, params)
      this.data = this.data = res.respuesta?.map((item) => {
        item.Address = item.Address || {}
        item.Address.Address = item.Address.Address || ''
        item.Address.PostCode = item.Address.PostCode || ''
        item.Address.Town = item.Address.Town || ''
        item.Address.Province = item.Address.Province || ''
        item.Address.CountryCode = item.Address.CountryCode || ''
        item.ContactDetails = item.ContactDetails || {}
        item.ContactDetails.Telephone = item.ContactDetails.Telephone || ''
        item.ContactDetails.TeleFax = item.ContactDetails.TeleFax || ''
        item.ContactDetails.WebAddress = item.ContactDetails.WebAddress || ''
        item.ContactDetails.ElectronicMail = item.ContactDetails.ElectronicMail || ''
        item.ContactDetails.ContactPersons = item.ContactDetails.ContactPersons || ''
        item.ContactDetails.CnoCnae = item.ContactDetails.CnoCnae || ''
        item.ContactDetails.INETownCode = item.ContactDetails.INETownCode || ''
        item.ContactDetails.AdditionalDetails = item.ContactDetails.AdditionalDetails || ''
        return item
      })
      const pagination = {
        total: res.meta?.total,
        currentPage: res.meta?.currentPage,
        totalPages: res.meta?.lastPage,
        pageSize: res.meta?.perPage
      }
      this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
      this.$store.commit('setIsLoading', false)
      this.loadingDataTable = false
      return this.data
    },
    async getMainData (objOrder, filters) {
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const data = await getSedesAdministrativeCentersPag(objOrder, params)
      if (data.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
      }
      return data
    },
    applyFiltersHandler: async function (eventData) {
      this.unselect()
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters(eventData)
    },
    changeCurrentPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', event)
      this.data = await this.applyFilters(null)
    },
    changePerPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.kendo.take = event
      this.data = await this.applyFilters(null)
    },
    removeFilterTagHanlder: function (tag) {
      this.unselect()
      // this.$store.commit(this.vuexnamespace + '/removeTag', tag)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      delete filter[tag[0]]
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      this.applyFiltersHandler(null)
    },
    headerCoreFiltersHandler: function (obs) {
      if (this.isHeadCoreReady) {
        this.applyFilters(null)
      }
    },
    removeAllTagsHandler: function () {
      this.unselect()
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.applyFiltersHandler(null)
    },
    downloadData: async function (id) {
      let sede = null
      try {
        this.$store.commit('setIsLoading', true)

        const params = {
          idSociedad: id,
          idSede: parseInt(this.$route.params.idSede)
        }
        sede = await getSede(params)
        if (sede.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', sede))
        } else {
          sede = sede.respuesta
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return sede
    },
    unselect: function () {
      this.selected = []
    },
    goNewAdministrativeCenter: function () {
      setTransitionAllowed(1, this.isIssuingCreation)
      setTransitionAllowed(2, this.isSocietyCreation)
      this.$router.push({ 
        name: 'masters/society/locations/administrativecenters/details', 
        params: { id: this.id, idSede: this.idSede, idCentro: -1 } 
      })
    },
    toggleSearchesDialog: function () {
      this.searchesPanel = !this.searchesPanel
    },
    saveTagsHandler: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    toggleDialogSearches: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    applySearchHandler: async function () {
      this.toggleDialogSearches()
      // Manda actualizar lista de búsquedas
      this.$refs.filterPanelSearches.updateData()
    },
    updateNumberSearches: async function (number) {
      this.numberSearches = number
    },
    goBack () {
      if (this.isIssuingCreation) {
        this.goEmission()
      } else if (this.isSocietyCreation) {
        this.$router.push({ name: 'masters/society' })
      } else {
        this.$router.push({ name: 'masters/society/locations/details' })
      }
    },
    goEmission () {
      setTransitionAllowed(1, true)
      this.$router.push({ 
        name: 'invoicesissuing',
        params: { issuingCreation: true, issuingType: this.issuingType }
      })
    },
  }
}
</script>

<style lang="scss" scoped></style>
